import React from 'react'
import AboutSection from './AboutSection'
import OurStory from './OurStory'
import OurMission from './OurMission'
import NextMakerApproach from './NextMakerApproach'
import OurCommunity from './OurCommunity'
import OurPartners from './OurPartners'
import JoinAdventure from './JoinAdventure'

function MainContent() {
   return (
      <div className="">
         <div className='w-full flex flex-col items-center pt-12 md:pt-16 px-4'>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold
            leading-snug md:leading-normal mb-3 md:mb-4 text-center text-dark-1 dark:text-white">
               A propos
            </h1>
            <span className='font-sans text-gray-600 dark:text-gray-300 text-sm md:text-base text-center max-w-md'>
               Découvrez notre histoire, notre mission et nos valeurs qui nous animent.
            </span>
         </div>
         <AboutSection />
         <OurStory />
         <OurMission />
         <NextMakerApproach />
         <OurCommunity />
         <OurPartners />
         <JoinAdventure />
         {/* <HowItWorks />
         <LearningJourney />
         <Testimonials />
         <FeatureSection />
         <BecomeInstructor />
         <BecomeStudent />
         <div className='w-full flex flex-col px-4'>
            <span className='flex justify-center w-full font-sans text-sm md:text-[15px] text-dark-1 
            dark:text-white pb-8 md:pb-16 text-center'>
               Trusted by the world's best
            </span>
            <ClientLogos />
         </div> */}
      </div>
   )
}

export default MainContent